import React from "react";
import { useSelector } from "react-redux";
import { selectDraftBoardForm } from "../../../../components/Settings/redux/selector";
import { selectSelectedTickets } from "../../../../redux/selector";
import { ListView } from "../../components/ListView";
import {
  selectGroupingLoader,
  selectTicketGroups,
} from "../../redux/selector";
import Loading from "./Loading";

export default function List() {
  const groups = useSelector(selectTicketGroups);
  const boardData = useSelector(selectDraftBoardForm);
  const selectedTickets = useSelector(selectSelectedTickets);
  const groupLoading = useSelector(selectGroupingLoader);

  if (groupLoading) return <Loading />;

  return (
    <div className="min-w-0 w-full">
      <ListView
        groups={groups}
        boardData={boardData}
        selectedTickets={selectedTickets}
      />
    </div>
  );
}